import React, { useEffect, useState, useContext } from 'react';
import {
    Grid,
    makeStyles,
    TextField,
    Select,
    FormControl,
    InputLabel,
    CircularProgress,
    FormHelperText,
} from '@material-ui/core';

import { Field } from 'formik';

import InputMask from 'react-input-mask';

import { useSelector, useDispatch } from 'react-redux';
import { fetchServiceDocuments } from 'app/store/slices/services';
import helpers from 'app/utils/helpers';
import { fecthAllCompanyTypes, fecthAllIndustry } from 'app/store/slices/company';
import { FormServiceContext } from 'app/utils/contexts';

import { SERVICES_CODES } from 'app/config/services';

import styles from './styles';
import RegistrationStatus from '../../../components/RegistrationStatus';
import { clearFiles } from 'app/store/slices/forms';
import { COMPANY_TYPES } from 'app/utils/constants';

import companyEndpoints from '../../../../../../api/services/companyEndpoints';
import notification from '../../../../../../config/notification';

const useStyles = makeStyles(styles);

const alteradoTipoComplementar = (activeCompany, value, companyTypes) => {
    const isTipoAtualComplementar =
        activeCompany?.tipoEmpresa?.boComplementar ?? activeCompany?.tipoPessoaFisica?.boComplementar;

    const isNovoTipoComplementar = companyTypes.find(
        (e) => Number(e?.cdTipoEmpresa ?? e?.cdTipoPessoaFisica) === Number(value),
    )?.boComplementar;

    return isTipoAtualComplementar && !isNovoTipoComplementar;
};

const alertaSolicitacaoAndamento = async (activeCompany) => {
    const response = await companyEndpoints.buscaSolicitacaoEmAndamentoComVeiculoComplementar(activeCompany.cdEmpresa);
    if (response && response.status === 200 && response.data !== '') {
        const tipoEmpresa = !!activeCompany?.tipoEmpresa ? 'Tipo de empresa' : 'Tipo de pessoa';
        return (
            <div>
                Não é permitida a alteração do {tipoEmpresa}, pois existe a solicitação {response.data} em andamento.
                <br />
                Aguarde a finalização para prosseguir com essa solicitação.
            </div>
        );
    }
    return '';
};

const alertaVeiculoComplementar = async (cdEmpresa) => {
    const response = await companyEndpoints.possuiVeiculoComplementarAtivo(cdEmpresa);
    if (response && response.status === 200 && !!response.data) {
        return '\n\nApós a aprovação dessa solicitação, o seu veículo do tipo complementar será baixado do sistema.';
    }
    return '';
};

export const confirmaAlteracaoTipoComplementar = async (activeCompany, value, values, companyTypes) => {
    let msg = 'A alteração do Tipo de empresa limpará a listagem de documentos, e o upload precisará ser refeito.';

    if (alteradoTipoComplementar(activeCompany, value, companyTypes)) {
        const msgAlertaSolicitacaoAndamento = await alertaSolicitacaoAndamento(activeCompany);
        if (!!msgAlertaSolicitacaoAndamento) {
            notification(msgAlertaSolicitacaoAndamento, { type: 'error' });
            return;
        }

        const msgAlertaVeiculoComplementar = await alertaVeiculoComplementar(activeCompany.cdEmpresa);
        values.flAlteradoTipoEmpresaPessoaComplementar = Boolean(msgAlertaVeiculoComplementar);
        msg += msgAlertaVeiculoComplementar;
    }
    msg += '\n\nDeseja continuar?';

    return window.confirm(msg);
};

function MainData(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const documentMask = '**.***.***/****-99';

    const companyTypes = useSelector((state) => state.company.companyTypes);
    const industry = useSelector((state) => state.company.industry);
    const service = useSelector((state) => state.services.details);
    const activeCompany = useSelector((state) => state.company.activeCompany);
    const request = useSelector((state) => state.requests.details);

    const [loadingCompanyTypes, setLoadingCompanyTypes] = useState(true);
    const [loadingIndustry, setLoadingIndustry] = useState(true);
    const [blockDoc] = useState(true);
    const [company, setCompany] = useState({});

    const { errors, touched, values, isHeadquarters, setIsHeadquarters } = props;

    useEffect(() => {
        if (Object.keys(company).length > 0) return;
        if (Object.keys(activeCompany).length > 0) {
            setCompany(activeCompany);
            return;
        }
        const cdEmpresa = request?.cdEmpresa ?? props.initialValues?.cdEmpresa;
        // na inscrição existe o cdEmpresa na request mas ele ainda não é válido; afinal, é uma solicitação de inscrição.
        if (cdEmpresa === undefined || service.cdServico === SERVICES_CODES.INSCRICAO_CADASTRAL) return;
        companyEndpoints.getCompany({ cdEmpresa }).then((res) => {
            if (res && res.status === 200) setCompany(res.data);
        });
        // eslint-disable-next-line
    }, [activeCompany, request, props.initialValues]);

    const { setLoadingDocuments, canEdit } = useContext(FormServiceContext);

    const onBlurRazaoSocial = ({ target: { value } }, values) => {
        if (service.cdServico === SERVICES_CODES.INSCRICAO_CADASTRAL) {
            return;
        }
        values.flAlteradoRazaoSocial = value !== company.deRazaoSocial;
    };

    const onChangeRepresentacao = (e) => {
        const value = e.target.value;
        setIsHeadquarters(value === 'M');
        values.flRepresentacao = value;
    };

    const onChangeCompanyType = async (e, values) => {
        const value = e.target.value;

        if (values && value) {
            if (String(values.cdTipoEmpresa) !== String(value)) {
                if (!(await confirmaAlteracaoTipoComplementar(company, value, values, companyTypes))) {
                    return;
                } else {
                    setLoadingDocuments(true);
                    values.documentos = [];
                    await dispatch(clearFiles());
                    setLoadingDocuments(false);
                }
            }

            values.cdTipoEmpresa = value;
            setLoadingDocuments(true);
            await dispatch(
                fetchServiceDocuments({
                    cdServico: service.cdServico,
                    cdTipoEmpresa: value,
                }),
            );
            setLoadingDocuments(false);
        }
    };

    useEffect(() => {
        const init = async () => {
            if (companyTypes.length === 0) {
                await dispatch(fecthAllCompanyTypes());
                await dispatch(fecthAllIndustry());
            }
            setLoadingIndustry(false);
            setLoadingCompanyTypes(false);
        };
        init();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
        if (values.flRepresentacao === 'M') {
            setIsHeadquarters(true);
        } else if (values.flRepresentacao === 'F') {
            setIsHeadquarters(false);
        }
    }, [setIsHeadquarters, values.flRepresentacao]);

    const validateDocument = (value) => {
        let error;
        if (!helpers.validateCpfCnpj(value)) {
            error = 'Documento inválido';
        }
        return error;
    };

    return (
        <Grid container spacing={3} className={classes.containerMainData}>
            <RegistrationStatus {...props} classes={classes} />

            <Grid item xs={12} sm={4}>
                {loadingCompanyTypes && <CircularProgress size={20} className={classes.loading} />}
                {!loadingCompanyTypes && (
                    <FormControl
                        variant="filled"
                        margin="dense"
                        fullWidth
                        error={!!errors.cdTipoEmpresa && touched.cdTipoEmpresa}>
                        <InputLabel htmlFor="cdTipoEmpresa" shrink={true}>
                            Tipo de empresa*
                        </InputLabel>
                        <Field
                            name="cdTipoEmpresa"
                            id="cdTipoEmpresa"
                            native
                            disabled={
                                !canEdit ||
                                activeCompany.cdTipoEmpresa === COMPANY_TYPES.GAS ||
                                service.cdServico === SERVICES_CODES.INATIVACAO_CADASTRAL ||
                                service.cdServico === SERVICES_CODES.RENOVACAO_CADASTRAL
                            }
                            as={Select}
                            onChange={(e) => onChangeCompanyType(e, values)}>
                            <option aria-label="None" value="">
                                Selecione
                            </option>
                            {companyTypes.map((type, index) => {
                                return (
                                    <option key={`type-${index}`} value={type.cdTipoEmpresa}>
                                        {type.deTipoEmpresa}
                                    </option>
                                );
                            })}
                        </Field>
                        {errors.cdTipoEmpresa && touched.cdTipoEmpresa ? (
                            <FormHelperText>{errors.cdTipoEmpresa}</FormHelperText>
                        ) : null}
                    </FormControl>
                )}
            </Grid>
            <Grid item xs={12} sm={4}>
                {loadingIndustry && <CircularProgress size={20} className={classes.loading} />}
                {!loadingIndustry && (
                    <FormControl
                        variant="filled"
                        margin="dense"
                        fullWidth
                        error={!!errors.cdRamoAtividade && touched.cdRamoAtividade}>
                        <InputLabel htmlFor="cdRamoAtividade" shrink={true}>
                            Ramo de Atividade*
                        </InputLabel>
                        <Field name="cdRamoAtividade" id="cdRamoAtividade" native disabled={!canEdit} as={Select}>
                            <option aria-label="None" value="">
                                Selecione
                            </option>
                            {industry.map((type, index) => {
                                return (
                                    <option key={`type-${index}`} value={type.cdRamoAtividade}>
                                        {type.deRamoAtividade}
                                    </option>
                                );
                            })}
                        </Field>
                        {errors.cdRamoAtividade && touched.cdRamoAtividade ? (
                            <FormHelperText>{errors.cdRamoAtividade}</FormHelperText>
                        ) : null}
                    </FormControl>
                )}
            </Grid>
            <Grid item xs={12} sm={4}>
                <FormControl
                    variant="filled"
                    margin="dense"
                    fullWidth
                    error={!!errors.flRepresentacao && touched.flRepresentacao}>
                    <InputLabel htmlFor="flRepresentacao" shrink={true}>
                        Representação na Bahia
                    </InputLabel>
                    <Field
                        name="flRepresentacao"
                        id="flRepresentacao"
                        onChange={(e) => onChangeRepresentacao(e)}
                        native
                        disabled={!canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC}
                        value={values.flRepresentacao ? values.flRepresentacao : 'M'}
                        as={Select}
                        validate={(value) => {
                            let error;
                            if (!value || value === '') {
                                error = 'Campo obrigatório';
                            }
                            return error;
                        }}>
                        <option value="M">Matriz</option>
                        <option value="F">Filial</option>
                    </Field>
                    {errors.flRepresentacao && touched.flRepresentacao ? (
                        <FormHelperText>{errors.flRepresentacao}</FormHelperText>
                    ) : null}
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
                {!blockDoc && canEdit && service.cdServico !== SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC ? (
                    <Field name="deCnpjMatriz" validate={validateDocument}>
                        {({ field, form: { errors, values } }) => (
                            <InputMask mask={documentMask} {...field} value={values.deCnpjMatriz}>
                                {(props) => (
                                    <TextField
                                        {...props}
                                        name="deCnpjMatriz"
                                        label="CNPJ Matriz*"
                                        variant="filled"
                                        margin="dense"
                                        fullWidth
                                        error={!!errors.deCnpjMatriz && touched.deCnpjMatriz}
                                        helperText={
                                            errors.deCnpjMatriz && touched.deCnpjMatriz ? errors.deCnpjMatriz : ''
                                        }
                                    />
                                )}
                            </InputMask>
                        )}
                    </Field>
                ) : (
                    <TextField
                        label="CNPJ Matriz*"
                        value={values.deCnpjMatriz ? helpers.formatarDocumento(values.deCnpjMatriz) : ''}
                        variant="filled"
                        margin="dense"
                        disabled
                        fullWidth
                    />
                )}
            </Grid>
            <Grid item xs={12} sm={4}>
                {!isHeadquarters && (
                    <>
                        {canEdit && service.cdServico !== SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC ? (
                            <Field name="deCnpjFilial" validate={validateDocument}>
                                {({ field, form: { errors, values } }) => (
                                    <InputMask mask={documentMask} {...field} value={values.deCnpjFilial}>
                                        {(props) => (
                                            <TextField
                                                {...props}
                                                name="deCnpjFilial"
                                                label="CNPJ Filial*"
                                                variant="filled"
                                                margin="dense"
                                                fullWidth
                                                error={!!errors.deCnpjFilial}
                                                helperText={errors.deCnpjFilial ? errors.deCnpjFilial : ''}
                                            />
                                        )}
                                    </InputMask>
                                )}
                            </Field>
                        ) : (
                            <TextField
                                label="CNPJ Filial*"
                                value={helpers.formatarDocumento(values.deCnpjFilial)}
                                variant="filled"
                                margin="dense"
                                disabled
                                fullWidth
                            />
                        )}
                    </>
                )}
            </Grid>
            <Grid item xs={12} sm={6}>
                <Field
                    name="deRazaoSocial"
                    label="Razão Social*"
                    variant="filled"
                    margin="dense"
                    disabled={
                        !canEdit ||
                        service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC ||
                        service.cdServico === SERVICES_CODES.INATIVACAO_CADASTRAL
                    }
                    fullWidth
                    error={!!errors.deRazaoSocial && touched.deRazaoSocial}
                    helperText={errors.deRazaoSocial && touched.deRazaoSocial ? errors.deRazaoSocial : ''}
                    as={TextField}
                    onBlur={(e) => onBlurRazaoSocial(e, values)}
                    inputProps={{
                        maxLength: 130,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Field
                    name="nmFantasia"
                    label="Nome Fantasia*"
                    variant="filled"
                    margin="dense"
                    disabled={!canEdit || service.cdServico === SERVICES_CODES.ATUALIZACAO_CADASTRAL_SEM_CRC}
                    fullWidth
                    error={!!errors.nmFantasia && touched.nmFantasia}
                    helperText={errors.nmFantasia && touched.nmFantasia ? errors.nmFantasia : ''}
                    as={TextField}
                    inputProps={{
                        maxLength: 130,
                    }}
                />
            </Grid>

            <Grid item xs={12}>
                <Field
                    name="deObservacao"
                    label="Observações"
                    variant="filled"
                    margin="dense"
                    disabled={!canEdit}
                    multiline
                    minRows={4}
                    fullWidth
                    as={TextField}
                    inputProps={{
                        maxLength: 4900,
                    }}
                />
            </Grid>
        </Grid>
    );
}

export default MainData;
